<template>
  <div class="Reportform">
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      inline
      label-width="4.8vw"
      style="margin-top: 20px"
    >
      <el-form-item prop="branchCompanyId" label="选择分公司" v-if="[1].includes(UserInfo.type)">
        <el-select
          filterable
          v-model="formScreen.branchCompanyId"
          value-key="company_id"
          @change="selectChange($event, 'listSonCompany')"
        >
          <el-option
            v-for="item in listBranchCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sonCompanyId" label="选择子公司" v-if="[2, 1].includes(UserInfo.type)">
        <el-select
          filterable
          v-model="formScreen.sonCompanyId"
          value-key="rid"
          @change="selectChange($event, 'listDepartment')"
        >
          <el-option
            v-for="item in listSonCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择平台" prop="sellerType">
				<el-select
					v-model="formScreen.sellerType"
					placeholder="请选择"
					@change="shopChange8"
					clearable
				>
					<el-option
						v-for="item in platform"
						:key="item.sellerType"
						:label="item.itemTypeName"
						:value="item.sellerType"
					></el-option>
				</el-select>
			</el-form-item>
      <el-form-item
        prop="departmentVal"
        label="选择分部门"
        v-if="UserInfo.system < 3 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.departmentVal"
          value-key="rid"
          @change="selectChange($event, 'listGroup')"
        >
          <el-option
            v-for="item in listDepartment"
            :key="item.rid"
            :label="item.departmentName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="groupVal"
        label="选择组"
        v-if="UserInfo.system < 4 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.groupVal"
          value-key="rid"
          @change="selectChange($event, 'listStaff')"
        >
          <el-option
            v-for="item in listGroup"
            :key="item.rid"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="staffVal"
        label="选择员工"
        v-if="UserInfo.system < 5 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.staffVal"
          value-key="rid"
          @change="selectChange($event, 'none')"
        >
          <el-option
            v-for="item in listStaff"
            :key="item.rid"
            :label="item.roleUserName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sid" label="选择店铺">
        <el-select v-model="formScreen.sid" :disabled="isShopDisabled">
          <el-option
            v-for="item in listShop"
            :key="item.id"
            :label="item.shop_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="uid" label="选择用户">
        <el-select v-model="formScreen.uid" @change="changeUser">
          <el-option :label="item.userName" :value="item.uid" v-for="item in userList" :key="item.uid"></el-option>
        </el-select>
      </el-form-item>
      <br/>
      <el-form-item prop="creditCardChannel" label="信用卡渠道">
        <el-select v-model="formScreen.creditCardChannel" filterable clearable>
          <el-option
            v-for="(item, index) in creditCardChannelList"
            :key="index+'qq'"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="countryMark" label="国家">
        <el-select v-model="formScreen.countryMark" filterable clearable>
          <el-option
            v-for="item in listCountry"
            :key="item.id"
            :label="item.countryName"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="exceptionType" label="异常类型">
        <el-select v-model="formScreen.exceptionType" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'ss'" v-for="(item, index) in exceptionTypeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="approvalStatus" label="审核状态">
        <el-select v-model="formScreen.approvalStatus" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'dd'" v-for="(item, index) in approvalStatusList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="abnormal" label="原因筛查">
        <el-select v-model="formScreen.abnormal" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'ff'" v-for="(item, index) in reasonForReturnList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="xiugaiTime" label="时间范围" style="width: 30%">
        <el-date-picker
          v-model="formScreen.xiugaiTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input
          placeholder="请输入订单号/订单ID"
          v-model="formScreen.searchVal"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm" :loading="searchBtnLoading">搜索</el-button>
        <el-button type="primary" @click="resetForm" :loading="searchBtnLoading">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="table-batch">
      <div>
        <el-button type="danger" style="margin-right: 10px;opacity: 0;">
          批量删除
        </el-button>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="setData">
          信用卡拒付手续费设置
        </el-button>
        <el-button type="primary" style="margin-right: 10px;" @click="dialogImportVisible=true">
          信用卡拒付导入
        </el-button>
      </div>
    </div>
    <el-table key="third" :data="listTable" border v-loading="loadingTable">
      <el-table-column label="订单号/终端号" align="center" width="200">
        <template slot-scope="scope">
          <p>订单号：{{ scope.row.amazonOrderId }}</p>
					<p>终端号：{{ scope.row.terminalNumber }}</p>
        </template>
      </el-table-column>
      <el-table-column align="left" label="产品信息" header-align="center" width="350">
        <template slot-scope="scope">
          <div
            class="details"
            v-for="(item, index) in scope.row.orderItemsList"
            :key="index"
          >
            <div class="details_left">
              <el-popover
                trigger="hover"
                placement="right"
                prop="orderItemsList.imageUrl"
                v-if="item.imageUrl"
              >
                <img
                  referrer="no-referrer|origin|unsafe-url"
                  :src="item.imageUrl"
                  alt
                  style="width:500px;height:500px;"
                />
                <div class="scope_img" slot="reference">
                  <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
                </div>
              </el-popover>
              <el-button
                type="text"
                size="mini"
                v-else
                @click="getOriginalImg(item)"
                style="padding: 0;"
                >查看原图</el-button
              >
            </div>
            <div class="details_right">
              <!-- <div
                style="width: 100%;"
                v-if="!scope.row.money"
              >
                <strong>price:</strong> - -
              </div> -->
              <div
                style="width: 100%;"
                v-if="scope.row.money"
              >
                <strong style="color:black">price:</strong> {{ item.itemAmount }}
                {{ item.itemCurrencyCode }}
              </div>
              <div
                style="width: 100%;"
                v-if="item.property !== null"
              >
                <strong style="color:black;">属性:</strong> {{ item.property }}
              </div>
              <div
                style="width: 100%;"
                v-if="item.customizeInfo"
              >
                <strong style="color:black;">定制信息:</strong> {{ item.customizeInfo }}
              </div>
              <div style="width: 100%;color:#dc143c" v-show="item.systemSku">
                <strong>系统SKU:</strong> {{ item.systemSku }}
              </div>
              <div style="width: 100%;">
                <strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
              </div>
              <div style="width: 100;" v-show="item.productSku">
                <strong style="color:black">产品SKU:</strong> {{ item.productSku }}
              </div>
              <!-- <div style="width: 100%;" v-if="scope.row.seller.sellerType == 2">
                海逊SKU: {{ item.sellerSKU }}
              </div> -->
              <el-divider v-if="scope.row.orderItemsList.length>1 && index!=(scope.row.orderItemsList.length-1)" class="orderDivider" />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="countryName" label="国家" align="center"></el-table-column>
      <el-table-column prop="exceptionType" label="异常类型" align="center"></el-table-column>
      <el-table-column prop="approvalStatus" label="审核状态" align="center"></el-table-column>
      <el-table-column prop="abnormalAmount" label="总额" align="center"></el-table-column>
      <el-table-column prop="currency" label="币种" align="center"></el-table-column>
      <el-table-column prop="totalPlatformCost" label="账户订单号/支付ID" align="center" width="200">
        <template slot-scope="scope">
          <p>账户订单号：{{ scope.row.accountOrderNumber }}</p>
					<p>支付ID：{{ scope.row.paymentId }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="abnormal" label="异常原因" align="center"></el-table-column>
      <el-table-column prop="transactionTime" label="交易时间" align="center"></el-table-column>
      <el-table-column prop="abnormalTime" label="异常时间" align="center"></el-table-column>
      <!-- <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="RenewalVisible=true">新增续费</el-button>
          <el-button type="primary" size="small" @click="historyVisible=true">查看历史记录</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-row type="flex" justify="center" align="middle" class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="page"
        :page-sizes="[20, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog
      title="信用卡拒付手续费设置"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="130px" class="dataForm">
        <el-form-item label="Paypal争议手续费" prop="handlingFee">
          <el-input-number v-model="dataForm.handlingFee" size="mini" :min="0">
          </el-input-number>
          <el-select v-model="dataForm.currency" placeholder="币种" filterable style="margin-left: 10px; width: 120px">
            <el-option
              v-for="item in exchangeRateList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          /单
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="btnSetLoading" @click="submitSet">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="信用卡拒付导入"
      :visible.sync="dialogImportVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-select v-model="creditCardChannel" filterable clearable>
        <el-option
          v-for="(item, index) in creditCardChannelList"
          :key="index+'qq'"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-row type="flex" align="middle" style="margin-top: 10px;">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <!-- <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button> -->
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写，该时区为美东-4时区时间。</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <div><span style="color: red">导入异常信息：</span></div>
        <span v-for="(item, index) in errorList" :key="index+'w'">{{ item }}<br /></span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          :loading="btnLoading"
          @click="handleUploadExcelSubmit"
        >确定导入
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增续费" width="25%" :visible.sync="RenewalVisible">
      <el-form label-width="100px">
        <el-form-item label="独立站平台">
          shopline
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="套餐选择">
          <el-select v-model="formData.taocan" filterable>
            <el-option label="套餐1" value="1"></el-option>
            <el-option label="套餐2" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月租">
          39.99 USD
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="手续费">
          0.2%
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker
            v-model="formData.value1"
            type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效时间">
          <el-select v-model="formData.taocan1" filterable>
            <el-option label="1年" value="1"></el-option>
            <el-option label="2年" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失效时间">
          2023年12月31日
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="RenewalVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="RenewalVisible = false"
          :loading="loadingStatus === 'RenewalVisible'"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看历史记录" width="50%" :visible.sync="historyVisible">
      <div slot="title" class="historyTitle">
        <div>查看历史记录</div>
        <div>独立站平台: shopline</div>
      </div>
      <ul class="historyUl">
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>试用期</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              免费天数 <strong>7</strong> 天
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2022年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              试用期间费率 <strong>0.2%</strong>
            </el-col>
          </el-row>
        </li>
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>续费期一</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2022年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              结束时间 <strong>2023年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              期间费率 <strong>0.2%</strong>
            </el-col>
          </el-row>
        </li>
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>续费期二</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2023年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              结束时间 <strong>2024年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              期间费率 <strong>0.7%</strong>
            </el-col>
          </el-row>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '@/api/api/api';
export default {
  name: "Dishonor",
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick: (picker) => {
            const date = new Date()
            picker.$emit('pick', date);
            this.calculationDate()
          }
        }, {
          text: '上一月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-1)
          }
        }, {
          text: '上两月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-2)
          }
        }, {
          text: '上三月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-3)
          }
        }]
      },
      UserInfo: {},
      companyId: '',
      rid: '',
      system: '',
      formScreen: {
        branchCompanyId: '',
        sonCompanyId: '',
        departmentVal: '',
        groupVal: '',
        staffVal: '',
        sid: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        sellerType: '',
        xiugaiTime: []
      },
      listBranchCompany: [],
      listSonCompany: [],
      listDepartment: [],
      listGroup: [],
      listStaff: [],
      listShop: [],
      dialogVisible: false,
      withdrawalRatio2: '',
      loadingStatus: '',
      listTable: [],
      loadingTable: false,
      page: 1,
      size: 20,
      total: 0,
      platform: [],
      searchBtnLoading: false,
      formData: {},
      RenewalVisible: false,
      historyVisible: false,
      dataForm: {handlingFee: 0},
      rules: {},
      exchangeRateList: [],
      dialogImportVisible: false,
      returnList: [],
      listFile: [],
      errorList: '',
      btnLoading: false,
      shopIds: [],
      listCountry: [],
      btnSetLoading: false,
      creditCardChannelList: [],
      exceptionTypeList: [],
      approvalStatusList: [],
      reasonForReturnList: [],
      userList: [],
      sidList: [],
      creditCardChannel: ''
    };
  },
  computed: {
    isShopDisabled() {
      if (this.UserInfo.system === 5 && this.UserInfo.superDepartmentName === '运营部') {
        return false
      } else {
        return !this.formScreen.staffVal
      }
    },
    screenObj() {
      return {
        companyId: this.companyId,
        rid: this.rid,
        system: this.system,
        sid: this.formScreen.sid,
      }
    }
  },
  watch: {
    dialogImportVisible(val) {
      if (!val) {
        this.listFile = []
        this.errorList = ''
        this.creditCardChannel = ''
      }
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getTable()
    this.getListCountry()
    this.getExchangeRateList()
    this.getSelectData()
    this.getUsers()
    if(this.UserInfo.type===3){
			this.getPlatform();
		}
  },
  methods: {
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      } else {
        listType = "listDepartment";
      }
      if (type === 3) {
        if (system === 3) {
          listType = "listGroup";
        } else if (system === 4) {
          listType = "listStaff";
        }
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    setData() {
      this.getSetData()
      this.dialogVisible = true
    },
    getSetData() {
      const API = Baseurl + 'creditCardChargebackController/selectCreditCardChargebackFee'
      const paramsData = {
        companyId: this.UserInfo.company_id
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code == 200 && res.data.data) {
          this.dataForm = res.data.data
        }
      })
    },
    getUsers() {
      const API = Baseurl + 'userControllers/selectUserListAndSidListByCompanyId'
      const paramsData = {
        companyId: this.UserInfo.company_id
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.userList = res.data.data
        } else {
          this.userList = []
          this.$message.error(res.data.data)
        }
      })
    },
    getListCountry() {
			const API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listCountry = data
				}
			})
		},
    getSelectData() {
			const API =
				Baseurl +
				'creditCardChargebackController/getCreditCardChargebackSearchCondition'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
          this.creditCardChannelList = data.creditCardChannelList
          this.exceptionTypeList = data.exceptionTypeList
          this.approvalStatusList = data.approvalStatusList
          this.reasonForReturnList = data.reasonForReturnList
				}
			})
		},
    // 获取汇率列表
		getExchangeRateList() {
			ajaxPost(Baseurl + 'rateController/getRatecurrencyCodeList').then((res) => {
				const { data: responseData } = res
				if (responseData.code === 200) {
					const { data } = responseData
					this.exchangeRateList = data
				}
			})
		},
    shopChange8() {
      if(this.UserInfo.type !== 3){
        this.rid = this.formScreen.sonCompanyId.rid;
        this.system = this.UserInfo.system;
      } else {
        this.rid = this.UserInfo.rid;
        this.system = this.UserInfo.system;
      }
      this.getNextPower(this.rid, this.system, this.companyId, 'listDepartment', true);
      this.formScreen.departmentVal = '';
      this.formScreen.groupVal = '';
      this.formScreen.staffVal = '';
      this.listStaff = [];
      this.formScreen.sid = '';
      this.listShop = []
      this.listGroup = [];
    },
    getPlatform() {
      const API = Baseurl + 'sellerController/selectStandalonePlatformList'
      ajaxPost(API, {rid: this.UserInfo.rid}).then((res) => {
        if(res.data.code === 200) {
          this.platform = res.data.data
        }else{
          this.platform=[]
          this.$message.error(res.data.data)
        }
      })
    },
    getNextPower(rid, system, companyId, type, bool=false) {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      let paramsData = { rid, system, companyId, sellerType: this.formScreen.sellerType };

      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
          if (bool) {
            this.shopIds = data.shopIds;
          }
        }
      });
    },
    selectChange(event, type) {
      this.formScreen.uid = ''
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);
      if (!system) this.system = this.UserInfo.system;
      if (!companyId) this.companyId = this.UserInfo.company_id;
      if (!rid) this.rid = this.UserInfo.rid;

      this.listShop = []
      this.formScreen.sid = ''
      if (type === "none") {
        this.getListShop()
        return;
      }
      this.getNextPower(rid, system, companyId, type, true);

      if (type == "listDepartment") {
        this.getPlatform();
      }

      this.formScreen.staffVal = {};
      this.listStaff = [];
      if (type === "listStaff") return;
      this.formScreen.groupVal = {};
      this.listGroup = [];
      if (type === "listGroup") return;
      this.formScreen.departmentVal = {};
      this.listDepartment = [];
      this.formScreen.sellerType = '';
      this.platform = [];
      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    changeUser() {
      this.formScreen.sellerType = ''
      this.formScreen.departmentVal = ''
      this.formScreen.groupVal = ''
      this.formScreen.staffVal = ''
      this.formScreen.sid = ''
      this.sidList = this.userList.filter(x => x.uid == this.formScreen.uid)[0].sidList
    },
    getTable() {
      const API = Baseurl + 'creditCardChargebackController/selectCreditCardChargebackPageInfo'
      const paramsData = {
        page: this.page,
        size: this.size,
        startTime: this.formScreen.xiugaiTime?this.formScreen.xiugaiTime[0]:'',
        endTime: this.formScreen.xiugaiTime?this.formScreen.xiugaiTime[1]:'',
        searchString: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        shopIds: this.shopIds,
        sidList: this.sidList,
        creditCardChannel: this.formScreen.creditCardChannel,
        exceptionType: this.formScreen.exceptionType,
        approvalStatus: this.formScreen.approvalStatus,
        abnormal: this.formScreen.abnormal,
        ...this.screenObj
      }
      this.loadingTable = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTable = false
        this.searchBtnLoading = false
        if (code === 200) {
          // data.list.forEach(item => item.amountChina = item.money.amountChina)
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    getListShop() {
      const API = Baseurl + 'sellerController/selectMyShopByRid1'
      const paramsData = {
        rid: this.rid,
        system: this.system
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listShop = data
        }
      })
    },
    searchForm() {
      this.searchBtnLoading = true
      this.page = 1
      this.getTable()
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.listBranchCompany = [];
      this.listSonCompany = [];
      this.listDepartment = [];
      this.listGroup = [];
      this.listStaff = [];
      this.listShop = [];
      this.sidList = [];
      this.shopIds = [];
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.companyId = this.UserInfo.company_id

      this.init();
      this.searchForm()
    },
    handleSizeChange1(val) {
      this.size = val
      this.getTable()
    },
    handleCurrentChange1(val) {
      this.page = val
      this.getTable()
    },
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = (month + type - 1 + 12) % 12 + 1;
      this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;
      const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
      this.formScreen.endTime = `${prevMonth} 23:59:59`
    },
    updateWithdrawalRatio() {
      const API = Baseurl + 'companyController/updateCompanyWithdrawalRatio'
      const paramsData = {
        id: this.UserInfo.company_id,
      }
      this.loadingStatus = 'dialogVisible'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.UserInfo.company = data
          localStorage.setItem('role', JSON.stringify(this.UserInfo))
          this.$message.success('操作成功')
          this.searchForm()
          this.dialogVisible = false
        }
      })
    },
    closeDialog() {},
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = []
      try {
        returnList = results.map(item => ({
          terminalNumber: item.终端号,
          accountOrderNumber: item.账户订单号,
          paymentId: item.支付ID,
          exceptionType: item.异常类型,
          currency: item.币种,
          amountOfTheTransaction: item.交易金额,
          abnormalAmount: item.异常金额,
          transactionTime: this.toMysqlData_2(item.交易时间),
          abnormalTime: this.toMysqlData_2(item.异常时间),
          replyDeadlineTime: this.toMysqlData_2(item.回复截止时间),
          approvalStatus: item.审核状态,
          abnormal: item.异常原因,
          countryLocated: item.ip所在国家,
          countryCard: item.卡所属国家,
          mail: item.邮箱,
          phone: item.联系方式,
          name: item.称呼,
          address: item.地址,
          zipCode: item.邮政编码,
          ipAddress: item.ip地址,
          sourceUrl: item.来源网址,
          preAuthorize: item.是否预授权,
          threeTransaction: item.是否为3D交易,
          deliveryStatus: item.妥投状态,
          state: item.州,
          city: item.城市,
          recipientAddress: item.收货人地址,
          consigneeCity: item.收货人城市,
          consigneeState: item.收货人州,
          consigneeZipCode: item.收货人邮编,
          consigneeCountry: item.收货人国家,
          consigneeName: item.收货人名,
          consigneeLastName: item.收货人姓,
          consigneePhone: item.收货人电话,
          trackingNumber: item.跟踪单号,
          logisticsWebsite: item.物流网址,
        }))
      } catch (_) {
        this.$message.error("文件错误，请核对文件格式")
        return
      }
      let bool1 = false
      let bool2 = false
      returnList.map(item => {
        if (item.transactionDate == "NaN-NaN-NaN") {
          bool1 = true
        }
        if (item.eventSubmissionDate == "NaN-NaN-NaN") {
          bool2 = true
        }
      })
      if (bool1 == true) {
        this.$message.error("交易日期格式有误，请按照正确格式填写！")
        return
      }
      if (bool2 == true) {
        this.$message.error("事件提交日期格式有误，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
    toMysqlData_2(time) {
      if (typeof time != 'number') throw new Error("请传入时间戳");
      time = new Date(1000 * parseInt(((time - 70 * 365 - 19) * 86400 - 8 * 3600)));
      time = time.toLocaleDateString() + " " + time.toLocaleTimeString();
      let times = time;
      let temp = [''];
      //将 2021/5/6 下午8:00:00 转换成 [2021,5,6,2,8,00,00]
      time.split('').forEach((v) => {
        if (!isNaN(parseInt(v))) temp[temp.length - 1] += v;
        else temp.push("");
      })
      //在转换完毕后，应为逻辑问题数组中会出现空元素
      time = temp;
      for (let index = 0; index < time.length; index++) {
        //去除数组中的空元素
        if (time[index] === '') { time.splice(index, 1); index-- };
        //如果时间只有个位数则在前面加上'0'
        time[index] = time[index].length < 2 ? '0' + time[index] : time[index];
      }

      return `${time[0]}-${time[1]}-${time[2]} ${(times.split("下午").length === 2 && parseInt(time[3]) != 12 ? parseInt(time[3]) + 12 : time[3])
        //转化为24小时格式  "2021-05-06 16:45:00" 
        }:${time[4]}:${time[5]}`;
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear() ;
      const month = time.getMonth() + 1 ;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelSubmit() {
      if (!this.creditCardChannel) {
        this.$message.error("请先选择信用卡渠道！")
        return
      }
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'creditCardChargebackController/importCreditCardChargeback/'+this.UserInfo.rid+'/'+this.creditCardChannel, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList
          } else {
            this.dialogImportVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.getTable()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    submitSet() {
      if (this.dataForm.handlingFee === undefined || this.dataForm.handlingFee === null) {
        this.$message.error("请输入手续费")
        return
      }
      if (!this.dataForm.currency) {
        this.$message.error("请选择币种")
        return
      }
      this.btnSetLoading = true
      ajaxPost(
        Baseurl + 'creditCardChargebackController/setCreditCardChargebackFee', {
          companyId: this.UserInfo.company_id,
          ...this.dataForm
        }
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("设置成功")
          this.closeSet()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnSetLoading = false
      }).catch(() => {
        this.btnSetLoading = false
      })
    },
    closeSet() {
      this.dataForm = {}
      this.dialogVisible = false
    }
  }
};
</script>

<style lang="scss" scoped>
.Reportform {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;
  .details {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.details_left {
		width: 30%;
		text-align: center;
	}
	.details_right {
		width: 70%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
  .scope_img img {
		width: 55px;
		height: 55px;
	}
  .table-batch {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    overflow: hidden;
    line-height: 40px;
    padding-bottom: 3px;
    margin-bottom: 5px;
    padding-top: 3px;
    background-color: #f9f3f3;
  }
  .historyTitle {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 100px;
  }
  .historyUl {
    li {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>
